module.exports = __webpack_public_path__ + "static/media/Stellar Queen Hydraulic Bed Base - 155x205 cm_Light Beige.dc7afb93.png";